<template>
  <div class="box">
    <div class="imgBox"><img src="../../../assets/luyouqi/luyouqi2.jpg" alt="" class="img"></div>
    <div class="row mt-3">
      <div class="col-12 pb-1 border-bottom">
        <h5 class="h5-sor">
          <!--                    -->                    VPN-WiFi路由器+15M速率4KVR版账号一个月 </h5>
        <span class="text-muted">包含价值199元15M速率4KVR版账号一个月 + 80元VPN路由器硬件</span>
      </div>

    </div>
    <div class="row d-flex  pl-1 pr-1 mt-3 mb-5 ">
      <a href="#buy" class="btn btn-primary btn-block">原价 289元，特价99元限量包邮抢购</a>
      <span class="d-block text-right w-100 pr-1">
                <small class="text-muted">
                    库存: 57 台 限量抢购                </small>
            </span>
    </div>
    <div>
      <b-tabs content-class="mt-3">
        <b-tab title="产品说明" active>
          <div class="myTabContent tab-content w-100 d-block">
            <div id="tab1">
              <h4 class="mt-0">产品特点</h4>
              <p>具有VPN加速功能的WiFi路由器</p>
              <p>可内置{{ this.common.name }}VPN会员账号（支持个人/企业版 / 4KVR版 / Pro版）；</p>
              <p>配置完成后，开机自动连接{{ this.common.name }}网络，无需任何操作；</p>
              <p>可支持6-8台设备，提供24小时不间断加速服务。</p>

              <h4>使用场景</h4>
              <p>手机、平板等便携设备及PC、MAC等桌面操作系统设备；</p>
              <p>全面支持PlayStation、Switch、Google TV、Apple TV、Xbox等设备使用；</p>
              <p>为中国大陆地区客户，提供内外网独立通道功能（不影响大陆地区原有网络访问）；</p>

              <h4>路由器性能参数</h4>
              <p>WLAN 802.11 B/G/N 2.4G 300Mbps速率</p>
              <p>互联网接口（WAN）X1 局域网接口（LAN）X4 USB2.0接口X1</p>
              <p>基于OpenWrt操作系统，内置VPN加密网络连接模块</p>
              <p>（VPN加密模块采用部分开源技术内置，如有侵权行为，还请邮件告知） <a target="_blank"
                                                                                :href="storeEmail">{{
                  this.common.email
                }}</a></p>

              <h4>维保声明</h4>
              <p>
                路由器设备在邮寄前均会经过详细测试，考虑产品特殊性，一经寄出后不提供保修服务，如出现邮寄损坏，您可以选择拒签或签收后的24小时内联络客服中心，我们将为您免费调换。</p>
              <h4>重要说明</h4>
              <p>路由器属于长期在线终端设备，故此，路由器上使用的{{
                  this.common.name
                }}账号，将无法同时在其他设备上登录，如需登录，请将路由器断电或离网即可。（具有5并发能力的Pro版本除外）</p>
            </div>
          </div>
        </b-tab>
        <b-tab title="使用方式">
          <div class="myTabContent tab-content w-100 d-block">
            <div id="tab2">
              <!--                    <p>--><!--</p>-->
              <!--                    <p>--><!--</p>-->
              <!--                    <p>--><!-- <a href="/product-order/course" target="_blank">--><!--</a></p>-->
              <!--                    <p>--><!--</p>-->
              <ul class="list-unstyled">
                <li>
                  <h4 class="mt-0">准备工作</h4>
                  <ul>
                    <li>将路由器WAN口，与您的网络连接（建议使用默认DHCP自动分配IP地址模式）；</li>
                    <li>将路由器接入电源启动；</li>
                    <li>等待WiFi列表中出现 Openwet-2.4G_XXXX时，点击接入此WiFi节点（接入密码默认：12345678）；</li>
                  </ul>
                </li>
                <li>
                  <h4>配置VPN账号</h4>
                  <ul>
                    <li>在浏览器地址栏中输入192.168.101.1；</li>
                    <li>在登录界面中，输入管理员用户名和密码（默认均为：admin）</li>
                    <li>进入路由器后，点击顶部菜单MyVPN – myconfig选项；</li>
                    <li>
                      <h5>在页面中自上至下</h5>
                      <ul>
                        <li>
                          勾选开机自动运行；
                        </li>
                        <li>
                          在VPN服务器中，输入{{ this.common.linkStr }}；
                        </li>
                        <li>
                          在用户名中，输入您的{{ this.common.name }}账号；
                        </li>
                        <li>
                          在密码中，输入您的密码。完成后，点击底部“保存&amp;应用”按钮，略等1分钟，设备将开始初始化连接。
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
                <li>
                  <h4>验证VPN是否已经连接</h4>
                  <ul>
                    <li>点击顶部菜单MyVPN – mystatus选项</li>
                    <li>查看自己访问海外的ip地址，是否与本地ip地址不同，如不同，则说明已经成功连接；</li>
                  </ul>
                </li>
                <li>
                  <h4>其他配置</h4>
                  <ul>
                    <li>
                      <h5>关于配置路由器WAN口上网的方法：</h5>
                      <ul>
                        <li>在路由器顶部菜单中，选择网络 – 接口选项；</li>
                        <li>在接口总览页面中，找到WAN口图标，点击右侧“修改”；</li>
                        <li>在接口-WAN配置页面中，点击协议下拉菜单，即可完成修改；</li>
                      </ul>
                    </li>
                    <li>
                      <h5>关于修改路由器WiFi用户名和接入密码:</h5>
                      <ul>
                        <li>在路由器顶部菜单中，选择网络 – 无线选项；</li>
                        <li>在无线概况页面中，点击右侧“修改”按钮；</li>
                        <li>
                          在修改页面底部的接口配置选项，通过“基本设置”可以修改WiFi名称，在“无线安全；中，可以修改WiFi接入密码。
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </b-tab>
        <b-tab title="路由器信息">
          <div class="myTabContent tab-content w-100 d-block">
            <div id="tab3">
              <p>路由器主机一台、DC电源适配器一个、RJ45网线一条；</p>
              <p>管理后台地址：192.168.101.1</p>
              <p>默认用户名/密码：admin</p>
              <p>默认WIFI信号名称：Openwrt – XXXX</p>
            </div>
          </div>
        </b-tab>
        <b-tab title="邮寄政策">
          <div class="myTabContent tab-content w-100 d-block">
            <div id="tab4">
              <p>除新疆、西藏、内蒙古、甘肃、青海、宁夏省份需要额外收取少量物流成本，其余省份均包邮。</p>
              <!--                    <span>--><!--</span>-->
              <!--                    <span>--><!--</span>-->
              <!--                    <span>--><!--</span>-->
              <!--                    <span>--><!--</span>-->
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </div>
    <div class="row mt-3">
      <div class="bd-callout bd-callout-info w-100">
        <p class="p-0 m-0">在线订购</p>
      </div>
    </div>
    <div class="row mb-3 px-1 py-1" id="buy">
      <form id="orderForm" class="w-100 mt-3" method="post" target="_blank">
        <div class="form-group row">
          <label class="col-3 col-md-2 pl-4 pr-0 col-form-label">抢购价</label>
          <div class="col-8 p-0 price">
            <strong><em class="rmb">¥</em>
              <em id="showprice">99.00</em><em id="showinfo" class="showinfo"></em></strong>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-3 col-md-2 pl-4 pr-0 col-form-label">数量</label>
          <div class="col-4 col-md-2 p-0">
            <el-input-number v-model="num" :min="1" :max="1000" label="描述文字"></el-input-number>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-3 col-md-2 pl-4 pr-0 col-form-label">收货人名称</label>
          <div class="col-8 p-0">
            <input type="text" class="form-control" name="name" placeholder="请输入收货人名称(必填)" v-model="name">
          </div>
        </div>
        <div class="form-group row">
          <label class="col-3 col-md-2 pl-4 pr-0 col-form-label">联系电话</label>
          <div class="col-8 p-0">
            <input type="text" class="form-control" name="phone" placeholder="请输入联系电话(必填)" v-model="phone">
          </div>
        </div>
        <div class="form-group row">
          <label class="col-3 col-md-2 pl-4 pr-0 col-form-label">所在地区</label>
          <div class="col-8 p-0">
            <el-cascader
                v-model="areaAll"
                :options="regions"
                style="width: 100%"
                placeholder="省/市/区县"
            />
          </div>
        </div>
        <div class="form-group row">
          <label class="col-3 col-md-2 pl-4 pr-0 col-form-label">详细地址</label>
          <div class="col-8 p-0">
            <input type="text" class="form-control" name="address"
                   placeholder="收货地址（省、市、区、街道及详细地址）其他留言"
                   v-model="detailAddress">
          </div>
        </div>
        <div class="form-group row">
          <label class="col-3 col-md-2 pl-4 pr-0 col-form-label">邮箱</label>
          <div class="col-8 p-0">
            <input type="text" class="form-control" name="email" placeholder="请输入您的常用邮箱（必填，重要)"
                   v-model="email">
          </div>
        </div>
        <div class="form-group row">
          <label class="col-3 col-md-2 pl-4 pr-0 col-form-label">留言</label>
          <div class="col-8 p-0">
            <textarea class="form-control" v-model="remark"></textarea>
          </div>
        </div>
        <div class="form-group row text-danger">
          <label class="col-3 col-md-2 pl-4 pr-0 col-form-label"></label>
          <div class="col-8 p-0">
            支付完成后，我们会通过邮件与您反馈订单进度，请确认此邮箱为您的常用邮箱。
          </div>
        </div>
        <div class="form-group row text-danger">
          <label class="col-3 col-md-2 pl-4 pr-0 col-form-label"></label>
          <div class="col-8 p-0">
            支付完成后，您的火焰云加速器账号将自动升级至15M 4KVR版本，1个月后将恢复原有业务。
          </div>
        </div>
        <input type="hidden" name="product_id" value="1">
        <input type="hidden" value="TVdZaGVZbmEYZ2AgDS4fNDQ.ExE3NiM5Gi4.DVQJFFQ3AW4cOhsEUw==">

        <br>

        <a @click="createOrder('alipay')" class="btn btn-success btn-block">立即抢购</a>

        <br>
        <a id="ukefu-point" @click="$router.push({name:'customer'})"
           class="w-100 btn btn-info ukefu-im-point">在线客服</a>
        <p class="mt-3 w-100 text-secondary mx-auto">
          路由器在未配置帐号前，不具备任何VPN能力，请放心收货。您的联系信息，我们将严格保密。</p>

      </form>
    </div>
    <footerPage></footerPage>
    <el-dialog
        title="手机微信扫码付款"
        :visible.sync="dialogVisible"
        width="250px"
        :show-close="false"
        center
        @opened="opened"
        @closed="closed"
        :before-close="handleClose">
      <div style="width: 100%;height: 200px">
        <div id="qrcode" ref="qrcode" style="margin: 0 auto"></div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import footerPage from "@/components/userInfo/footer";
import regions from "@/assets/json/regions.json"
import Qrcode from "qrcodejs2"
import {getUserId} from "@/axios/token";

export default {
  name: "productPage",
  components: {footerPage},
  data() {
    return {
      storeEmail: 'mailto:' + this.common.email,
      dialogVisible: false,
      regions: regions,
      num: 1,
      name: '',
      phone: '',
      detailAddress: '',
      email: '',
      remark: '',
      areaAll: "",
      codeURL:'',
      object_id:0,
      userid: parseInt(getUserId())
    }
  },
  computed:{
    provinces(){
      return this.areaAll[0] + this.areaAll[1] + this.areaAll[2]
    }
  },
  methods: {
    handleClose(done) {
      done();
    },
    opened() {
      this.makeQrcode(this.codeURL)
    },
    closed() {
      document.getElementById("qrcode").innerHTML = "";
    },
    async createOrder(method) {
      let data = {
        mode: 1,//先默认走易支付
        payment_method: method,
        user_id: this.userid,
        payed_amount: this.num,
        order_amount: this.num,
        object_id: 0,
        delivery_address: this.provinces,
        delivery_name: this.name,
        memo: this.remark,
        num: this.num,
        name: this.name,
      }
      await this.axios.post('/order/new', data, this.common.configjson).then(res=>{
        let payUrl = JSON.parse(res.data.data)
        if (method === 'wxpay') {
          this.codeURL = payUrl;
          this.dialogVisible = true;
        } else if (method === 'alipay') {
          // 点击方法 url为传入的第三方链接或网址
          window.open(payUrl)
        }
      });

    },
    makeQrcode(codeUrl) {
      new Qrcode(this.$refs.qrcode, {
        width: 200,
        height: 200,
        colorDark: '#333',//二维码颜色
        colorLight: '#fff',//二维码背景颜色
        text: codeUrl,
        correctLevel: Qrcode.CorrectLevel.L//容错率,L/M/H
      })
    }
  }
}
</script>

<style scoped lang="scss">
.imgBox {
  max-width: 750px;
  max-height: 500px;
  margin: 0 auto;

  .img {
    width: 100%;
    height: 100%;
  }
}

.myTabContent {
  padding: 0 10px;
}

.myTabContent span {
  display: block;
  margin-top: 10px;
  font-size: .8rem;
}

.myTabContent p {
  margin-bottom: .2rem;
}

.myTabContent h4 {
  color: #2d8eff;
  margin-top: 2rem;
}

.myTabContent .tab-pane {
  padding-top: 1rem;
}

.bd-callout-info {
  border-left-color: #2d8eff;
}

.bd-callout {
  padding: .5rem;
  margin-top: 1.25rem;
  margin-left: .5rem;
  /*margin-right: .5rem;*/
  //#5bc0de
  border: 1px solid #eee;
  border-left: 0.25rem #2d8eff;
  border-radius: .25rem;
}

.price strong {
  height: 26px;
  font: 28px/26px Tahoma;
  font-weight: 600;
  color: #F40;
}

.form-group {
  margin-bottom: .5rem;
}

.btn-primary {
  color: #fff;
  background-color: #E74C3C;
  border-color: #2d8eff;
  transition: background-color 2s;
  -moz-transition: background-color 2s;
  -webkit-transition: background-color 2s;
  -o-transition: background-color 2s;
  width: 100%;
}

@media (min-width: 300px) and (max-width: 767px) {
  .h5-sor {
    font-size: 1.1rem;
  }

  .h5-sor small {
    font-size: 75%;
  }

  .account-info dt {
    /*-ms-flex: 0 0 28.333333%;*/
    /*flex: 0 0 28.333333%;*/
    /*max-width: 33.333333%;*/
  }

  .account-info > dt {
    padding-right: 0;
  }

  .account-info > dd {
    padding-left: 0;
    padding-right: 0;
  }

  .down-groups {
    font-size: .8rem;
  }

  form .row {
    margin-left: 0;
    margin-right: 0;
  }
}

@media (min-width: 768px) {
  .h5-sor {
    font-size: 2rem;
  }

  .account-info {
    font-size: 1rem;
  }

  .account-info > dt {
    padding-right: 0;
  }

  .container-md {
    max-width: 960px;
  }
}
</style>